export enum ScaleCode {
    GES = 'GES',
    DPE = 'DPE'
}

// TODO move to TailoredStandardWidget
export interface WidgetScaleConfig {
    widgetTitle: string;
    widgetSubtitle: string;
    valueLabel: string;
    referenceLabel: string;
    minRangeLabel: string;
    maxRangeLabel: string;
}
export interface ScaleRange {
    code: string;
    label: string;
    color: string;
    maxValue: number;
}

export interface Scale {
    scaleCode: ScaleCode;
    scaleCategory: string;
    scaleRanges: ScaleRange[];
}

export const SCALE_CATEGORY_ADVIZEO_ATTRIBUTE_CODE = 'building_regulatory_label_type';
export const DEFAULT_SCALE_CATEGORY = 'office_school';
